

































































import Vue from "vue";

const pdfDefaultPreview =
  "https://trashbuttonstorage.blob.core.windows.net/journeysketchimages/pdfpreview.png";
function getBase64(input: any) {
  return new Promise(function(resolve, reject) {
    const reader = new FileReader();
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(input as any);
  });
}

export default Vue.extend({
  props: {
    itemValue: String,
    isSmallDevice: Boolean,
    boldLabel: Boolean,
    isRequired: Boolean,
    locationObject: {
      type: Object,
      default: () => {
        return {
          routeSketchFirst: ""
        };
      }
    }
  },
  data: () => {
    return {
      routeSketchFirst: "",
      sketchSource1: "",
      sortDesc: false,
      mimes: "image/png,image/jpeg,image/jpg,application/pdf",
      file: [] as any,
      uploadName1: "",
      currentName1: "",
      slot1: false,
      fileSize1: 0,
      RouteSketches: {
        routeSketchFirst: { name: "", file: "" },
      }
    };
  },
  created() {
    if (
      this.locationObject.routeSketchFirst &&
      this.locationObject.routeSketchFirst !== null &&
      this.locationObject.routeSketchFirst !== ""
    ) {
      const urlArray = this.locationObject.routeSketchFirst.split(
        "/" + this.locationObject.id + "_"
      );
      const fileName = urlArray[urlArray.length - 1];
      this.uploadName1 = fileName;
      this.currentName1 = fileName;
      this.routeSketchFirst = this.locationObject.routeSketchFirst;
      if (fileName.indexOf(".pdf") < 0) {
        this.sketchSource1 = this.locationObject.routeSketchFirst;
      } else {
        this.sketchSource1 = pdfDefaultPreview;
      }
      this.slot1 = true;
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    sketchClass() {
      if(this.isMobile) {
        return 'sketch-mobile-image-form sketch-image-form';
      } else {
        return 'sketch-desktop-image-form sketch-image-form';
      }
    },
    directionSketchLabel() {
      return this.isRequired ? "Anfahrtsskizze" : "Anfahrtsskizze (optional)"
    }
  },
  methods: {
    cancelFile(sketchNumber: number) {
      this.uploadName1 = "";
      this.routeSketchFirst = "";
      this.slot1 = false;
      this.sketchSource1 = "";
      this.fileSize1 = 0;
      this.RouteSketches = {
        routeSketchFirst: { name: this.uploadName1, file: this.routeSketchFirst },
      }
      this.$emit('set-changes', this.RouteSketches);
    },
    async handleSketchFiles() {
      const fileInput = this.file;
      if (fileInput != null) {
        const fileInputType = fileInput!.type;
        const fileSize = fileInput!.size;
        const correctType = this.mimes
          .split(",")
          .find(m => m === fileInputType);
        if (!correctType) {
          this.$toast.error("file types is not supported", {
            timeout: 5000
          });
          return;
        }
        if (this.slot1 !== true) {
          if (fileSize >= 5000000) {
            this.fileSize1 = 0;
            this.$toast.error(
              "Die Dateigröße hat maximal 5 MB erreicht. Bitte wählen Sie kleiner oder reduzieren Sie Ihre Dateigröße.",
              {
                timeout: 7000
              }
            );
            return;
          }
          const base64String = await getBase64(fileInput);

          if (fileInputType === "application/pdf") {
            this.sketchSource1 = pdfDefaultPreview;
          } else {
            this.sketchSource1 = base64String as string;
          }
          this.uploadName1 = fileInput!.name;
          this.routeSketchFirst = base64String as string;
          this.slot1 = true;
        } else {
          this.$toast.error("max files amount has been reached");
          return;
        }
        this.RouteSketches = {
          routeSketchFirst: { name: this.uploadName1, file: this.routeSketchFirst },
        }
        this.$emit('set-changes', this.RouteSketches);
      }
    },
  }
});
